module.exports = __webpack_public_path__ + "img/129.d7e68a79.jpg";